import styled from 'styled-components';

import ArrowIcon from '@/assets/icons/empty-channels-arrow.svg';
import { BREAKPOINTS } from '@/constants/breakpoints';
import {
  FlexCenterAligned,
  FlexColumn,
  FlexColumnCenterAligned
} from '@/styled/common';

export const ChannelsMainContainer = styled(FlexColumn)`
  height: calc(100vh - 60px);
  overflow: hidden;
  background-color: ${({ theme }) => theme.bg.main};
  min-width: 410px;

  @media (max-width: ${BREAKPOINTS.Mobile}px) {
    min-width: 100%;
    height: 100%;
  }
`;

export const ChannelsMainLoader = styled(FlexColumnCenterAligned)`
  height: 100%;
  border-right: ${({ theme }) => `1px solid ${theme.border.main}`};
`;

export const ChannelsTitleBlock = styled.div`
  padding: 26px 30px;
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.main};
  border-right: ${({ theme }) => `1px solid ${theme.border.main}`};

  @media (max-width: ${BREAKPOINTS.Mobile}px) {
    border-right: 0;
    padding: 18px 30px;
  }
`;

export const ChannelsListContainer = styled(FlexColumn)`
  height: calc(100% - 60px);
  overflow-y: auto;
  padding-bottom: 15px;
`;

export const ChannelsEmptyContainer = styled(FlexColumnCenterAligned)`
  height: 100%;
  padding: 20px;
`;

export const ChannelsEmptyBlock = styled(FlexColumn)`
  align-items: center;
  gap: 20px;
`;

export const ChannelsArrowIcon = styled(ArrowIcon)`
  stroke: ${({ theme }) => theme.text.main};
`;

export const ChannelsPlaceholderTextTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.main};
  text-align: center;
`;

export const ChannelsPlaceholderTextMessage = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.text.secondary};
  text-align: center;
`;

export const LoaderContainer = styled(FlexCenterAligned)`
  min-height: 75px;
  border-right: ${({ theme }) => `1px solid ${theme.border.main}`};
`;
